<template>
  <!-- prettier-ignore -->
  <div class="person-name">
    <div
      class="person-name__label"
      v-text="$props.person.firstName"
    />
    <div
      v-if="!noAge && $props.person.age > 0"
      class="person-name__age">
      ({{ $props.person.age }}<template v-if="isBirthday && browser.isDesktop"> 🎂</template>)
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { DateTimeHelper } from '@/helpers/DateTime'

import { useBrowser } from '@/hooks'

// Hooks
const { browser } = useBrowser()

const props = defineProps({
  noAge: {
    type: Boolean,
    default: false,
  },

  person: {
    type: Object,
    required: true,
  },
})

// Computed

const isBirthday = computed(() => {
  return DateTimeHelper.isBirthday(props.person.personData.dateOfBirth)
})
</script>

<style name="mobile" scoped>
.person-name {
  display: flex;

  &__label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__age {
    padding-left: 5px;
    white-space: nowrap;
  }
}
</style>
